import { render, staticRenderFns } from "./TicketsSend.vue?vue&type=template&id=05f3525c&"
import script from "./TicketsSend.vue?vue&type=script&lang=js&"
export * from "./TicketsSend.vue?vue&type=script&lang=js&"
import style0 from "./TicketsSend.vue?vue&type=style&index=0&id=05f3525c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports